import type { FC, PropsWithChildren, Ref } from 'react';
import React from 'react';

import type { IClassNameProps } from '@bem-react/core';

import { cnTextarea } from '../Textarea.cn';

import './Textarea-Wrap.css';

export type TextareaWrapProps = IClassNameProps &
    PropsWithChildren<{
        /**
         * Ссылка на враппер DOM-элемента нативного инпута.
         */
        innerRef?: Ref<HTMLSpanElement>;
    }>;

export const TextareaWrap: FC<TextareaWrapProps> = ({
    className,
    innerRef,
    children,
    ...props
}) => (
    <span {...props} className={cnTextarea('Wrap', null, [className])} ref={innerRef}>
        {children}
    </span>
);
